






import { Component, Vue } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'

@Component
export default class ComponentPageContent extends Vue {
  private styleGrid!: IStyle
  private $style!: IStyle
  private styleMobileGrid!: IStyle

  private get isMobile(): boolean {
    return this.$device.isMobileOrTablet
  }

  private get classWrapper() {
    return {
      [this.styleGrid.container]: !this.isMobile,
      [this.styleMobileGrid.container]: this.isMobile,
      [this.$style.wrapperMobile]: this.isMobile,
    }
  }
}
